import { getBaseUrl } from 'utils/helperMethods';

//URLS
export enum Urls {
    depletionBarChartUrl = 'depletion',
    depletionDrilldownUrl = 'depletion/attr_timeseries',
}

const baseUrl = getBaseUrl();

export const filterUrls = {
    getAttributeNamesUrl: baseUrl + 'dimension/attribute_names',
};

export const roiTrackerUrls = {
    investmentTypeDropdownUrl: baseUrl + 'media/investment_types',
    roiTrackerGraphUrl: baseUrl + 'media/graph_investments_data',
    roiTrackerTableUrl: baseUrl + 'media/tracker_table_data',
};

export const bumpReportUrls = {
    incrementsPromoUrl: baseUrl + 'bump_report/incremental_promo_trends',
    incrementsPromoExportUrl: baseUrl + 'bump_report/incremental_promo_trends_export',
    incrementsPromoComparisonExportUrl: baseUrl + 'bump_report/cy_ya_incremental_promo_trends_export',
    groupByUrl: baseUrl + 'bump_report/top_attribute_trends',
    groupByExportUrl: baseUrl + 'bump_report/top_attributes_trend_export',
    groupByComparisonExportUrl: baseUrl + 'bump_report/cy_ya_top_attributes_trend_export',
    bumpReportCalenderUrl: baseUrl + 'bump_report/promo_calendar',
    lineChartUrl: baseUrl + 'bump_report/derived_trends',
    mediaTypesUrl: baseUrl + 'bump_report/media_types',
};

export const commercialForecastUrls = {
    graphDataUrl: baseUrl + 'commercial_forecast/graph_data',
    tableDataUrl: baseUrl + 'commercial_forecast/table_data',
    trendGraphUrl: baseUrl + 'commercial_forecast/data_trend',
};

export const PVMUrls = {
    YearDropdownUrl: baseUrl + 'pvm/max_date',
    PlansDropdownUrl: baseUrl + 'pvm/comparison_list',
    FeatureGroupsDataUrl: baseUrl + 'pvm/feature_groups_data',
    FeatureDataUrl: baseUrl + 'pvm/features_data',
    FeatureTableDataUrl: baseUrl + 'pvm/table_data',
    GroupTimeSeriesUrl: baseUrl + 'pvm/group_timeseries_data',
    FeatureTimeSeriesUrl: baseUrl + 'pvm/feature_timeseries_data',
    FeatureAttributeDataUrl: baseUrl + 'pvm/feature_attribute_data',
};

export const PortfolioUrls = {
    MediaTypesUrl: baseUrl + 'media/media_types',
    MediaTypesDataUrl: baseUrl + 'media/media_roi_analysis_data',
    roiAnalysisKpiDataUrl: baseUrl + 'roi_analysis/kpis',
    roiAnalysisTableDataUrl: baseUrl + 'roi_analysis/table_data',
    roiAnalysisTableDataExportUrl: baseUrl + 'roi_analysis/table_data_export',
};

export const priceCurveUrls = {
    levelStatus: baseUrl + 'price_curve/levels_enabled_status',
};

// price simulator v2 urls
export const pricingSimulatorUrls = {
    // get calls
    getDimensionConfigDataUrl: baseUrl + 'pricing_simulator_v2/project/get_project_dimensions',
    getAllProjectsUrl: baseUrl + 'pricing_simulator_v2/project/project_details',
    getProjectAccess: baseUrl + 'pricing_simulator_v2/project',
    getAllScenariosUrl: baseUrl + 'pricing_simulator_v2/scenario',
    getProjectFiltersUrl: baseUrl + 'pricing_simulator_v2/project/get_project_filters',
    getLenseConfigUrl: baseUrl + 'pricing_simulator_v2/lens_kpi/get_lens_kpis_config',
    getSingleProjectDetailsUrl: baseUrl + 'pricing_simulator_v2/project/get_project_details_by_id',
    getSingleScenarioDetailsUrl: baseUrl + 'pricing_simulator_v2/scenario/details',
    getSingleProjectDetailsByScenarioIdUrl: baseUrl + 'pricing_simulator_v2/project/get_project_details_by_scenario_id',
    getSingleScenarioLenseDataUrl: baseUrl + 'pricing_simulator_v2/scenario/fetch_scenario_data',
    getFilterAttributes: baseUrl + 'pricing_simulator_v2/scenario/attribute_names',
    getScenarioStatusById: baseUrl + 'pricing_simulator_v2/scenario/scenario_status',
    // post calls
    editKpiUrl: baseUrl + 'pricing_simulator_v2/scenario/apply_changes',
    postUpdateLenseConfig: baseUrl + 'pricing_simulator_v2/lens_kpi/update_lens_kpi_config',
    postUpdateLastViewedLense: baseUrl + 'pricing_simulator_v2/lens_kpi/update_last_viewed_lens',
    createProjectUrl: baseUrl + 'pricing_simulator_v2/project/create_project',
    updateProjectUrl: baseUrl + 'pricing_simulator_v2/project/update_project',
    updateFilterUrl: baseUrl + 'pricing_simulator_v2/scenario/update_filter',
    updateScenarioUrl: baseUrl + 'pricing_simulator_v2/scenario/update_scenario',
    updateDelistOrCompFollowStatusUrl: baseUrl + 'pricing_simulator_v2/scenario/update_scenario_column',
    simulateScenarioUrl: baseUrl + 'pricing_simulator_v2/scenario/simulate',
    createNewScenario: baseUrl + 'pricing_simulator_v2/scenario/create_scenario',
    duplicateScenario: baseUrl + 'pricing_simulator_v2/scenario/duplicate_scenario',
    resetScenarioUrl: baseUrl + 'pricing_simulator_v2/scenario/reset_scenario',
    reloadScenarioUrl: baseUrl + 'pricing_simulator_v2/scenario/reload_scenario',
    //delete calls
    deleteScenarioUrl: baseUrl + 'pricing_simulator_v2/scenario/delete_scenario',
    //export calls
    exportScenarioUrl: baseUrl + 'pricing_simulator_v2/scenario/export_scenario_data',
    exportScenarioStatusUrl: baseUrl + 'pricing_simulator_v2/scenario/export_scenario_status',
    getScenarioDataCount: baseUrl + 'pricing_simulator_v2/scenario/fetch_scenario_data_count',
    uploadScenarioExcel: baseUrl + 'pricing_simulator_v2/scenario/upload_scenario_template',
    downloadTemplate: baseUrl + 'pricing_simulator_v2/scenario/download_template',
    getUploadStatus: baseUrl + 'pricing_simulator_v2/scenario/get_upload_status',
};

//analytics urls
export const pricingAnalyticsUrls = {
    addBaseScenarioUrl: baseUrl + 'pricing_simulator_v2/scenario_analytics/create_update_report',
    getReportsListUrl: baseUrl + 'pricing_simulator_v2/scenario_analytics/list_reports',
    getReportMetaDataUrl: baseUrl + 'pricing_simulator_v2/scenario_analytics/report_metadata',
    getChangeAnalyticsDataUrl: baseUrl + 'pricing_simulator_v2/scenario_analytics/fetch_change_analytics_data',
    getCategoryMovementKpiChartDataUrl:
        baseUrl + 'pricing_simulator_v2/scenario_analytics/fetch_category_movement_data',
    getCategoryMovementChartByLevelDataUrl:
        baseUrl + 'pricing_simulator_v2/scenario_analytics/fetch_category_movement_by_level',
    getGlobalKPIsDataUrl: baseUrl + 'pricing_simulator_v2/scenario_analytics/fetch_global_kpi_tiles',
    deleteGlobalKPIUrl: baseUrl + 'pricing_simulator_v2/scenario_analytics/remove_global_kpi',
    updateReportNameUrl: baseUrl + 'pricing_simulator_v2/scenario_analytics/rename_report',
    getReportAccess: baseUrl + 'pricing_simulator_v2/scenario_analytics',

    //comparison urls
    getComparisonMetaDataUrl:
        baseUrl + 'pricing_simulator_v2/scenario_analytics/get_report_comparison_scenario_details',
    getHeatmapTableDataUrl: baseUrl + 'pricing_simulator_v2/scenario_analytics/get_heatmap_comparison_data',
    updateReportScenarioList:
        baseUrl + 'pricing_simulator_v2/scenario_analytics/update_report_comparison_scenario_list',
    updateReportFilter: baseUrl + 'pricing_simulator_v2/scenario_analytics/update_report_filter',
    deleteScenarioFromReportUrl: baseUrl + 'pricing_simulator_v2/scenario_analytics/remove_scenario_from_comparison',
    getTierViewData: baseUrl + 'pricing_simulator_v2/scenario_analytics/get_tier_view_data',
};

//tpo urls
export const tradePromoOptimizationUrls = {
    getKpiConfigDataUrl: baseUrl + 'promo_recommendation/tpo/tpo_kpi_view_config',
    getPlanConstraintsUrl: baseUrl + 'promo_recommendation_v1/plan_constraints',
    getPlaybookKpiConfigDataUrl: baseUrl + 'promo_recommendation/tpo/get_playbook_kpis',
    getAllPlansUrl: baseUrl + 'promo_recommendation/tpo/plan_details',
    getPlanFilters: baseUrl + 'promo_recommendation/tpo/get_plan_filters',
    getPlanMetaDataUrl: baseUrl + 'promo_recommendation/tpo/plan_meta_data',
    getPlanEditMetaDataUrl: baseUrl + 'promo_recommendation/tpo/plans',
    createPlanUrl: baseUrl + 'promo_recommendation/tpo/create_promo_plan',
    updatePlanUrl: baseUrl + 'promo_recommendation/tpo/update_promo_plan',
    deletePlanUrl: baseUrl + 'promo_recommendation/tpo/delete_promo_plan',
    getBaselineVolumeVersionsUrl: baseUrl + 'promo_recommendation/tpo/plans/base_volume_versions',
    getOfferDataUrl: baseUrl + 'promo_recommendation/tpo/get_offer_type',
    getPromosByEventId: baseUrl + 'promo_recommendation/tpo/get_promos_by_event_id',
    getPromoDetailsByPromoId: baseUrl + 'promo_recommendation/tpo/get_promo_details_by_promo_id',
    postPromoDetails: baseUrl + 'promo_recommendation/tpo/upsert_event_promo',
    getPromoMetricsConfigUrl: baseUrl + 'promo_recommendation/tpo/promo_tactics_config',
    getMetricsRecommendedValues: baseUrl + 'promo_recommendation/tpo/metrics_recommended_values',
    getAttributeListUrl: baseUrl + 'promo_recommendation/tpo/get_event_filters_list',
    getOptimizationOrgValues: baseUrl + 'promo_recommendation/tpo/get_optimization_original_vals',
    getObjectives: baseUrl + 'promo_recommendation/tpo/get_objectives',
    getObjectivesWithDefaultConstraints: baseUrl + 'promo_recommendation/tpo/get_objectives_with_default_constraints',
    runOptimization: baseUrl + 'promo_recommendation/tpo/run_optimization',
    getEventDataByIdUrl: baseUrl + 'promo_recommendation/tpo/event_meta_data',
    getCalenderDataUrl: baseUrl + 'promo_recommendation/tpo/calendar_data',
    getKpiTableDataUrl: baseUrl + 'promo_recommendation/tpo/kpi_table',
    getPlanSummaryTableDataUrl: baseUrl + 'promo_recommendation/tpo/plan_summary_table',
    createEditEventUrl: baseUrl + 'promo_recommendation/tpo/upsert_event',
    createEditEventLibraryUrl: baseUrl + 'promo_recommendation/tpo/upsert_event_in_event_library',
    getEventsForEventsLibraryUrl: baseUrl + 'promo_recommendation/tpo/fetch_events_from_event_library',
    importEventsLibraryUrl: baseUrl + 'promo_recommendation/tpo/import_events_from_library',
    importEventsFromPlanUrl: baseUrl + 'promo_recommendation/tpo/import_events_from_plans',
    getPlansForImportUrl: baseUrl + 'promo_recommendation/tpo/fetch_plans_for_events_import',
    getEventsByPlanIdForImportUrl: baseUrl + 'promo_recommendation/tpo/fetch_events_from_plans',
    getOptimizationResult: baseUrl + 'promo_recommendation/tpo/get_optimized_results',
    // getRbacDataUrl: 'https://dummyjson.com/c/fd62-13f2-449b-b558',
    // getRbacDataUrl: 'https://rbac-service-eastus-staging.azure.dynamicdemand.ai/rbac/feature_level_data_restrictions',
    getRbacDataUrl: 'https://rbac-service-eastus-staging.asper.dynamicdemand.ai/rbac/feature_level_data_restrictions',
    deleteEventUrl: baseUrl + 'promo_recommendation/tpo/delete_event',
    copyEventPromoUrl: baseUrl + 'promo_recommendation/tpo/copy_event_promo',
    deletePromoUrl: baseUrl + 'promo_recommendation/tpo/delete_promo',
    syncTpoUrl: baseUrl + 'promo_recommendation/tpo/delete_plan_for_sync',
    getPromoLibraryTableDataUrl: baseUrl + 'promo_recommendation/tpo/get_promo_library_kpis_data',
    getPromoLibraryTableDataExportUrl: baseUrl + 'promo_recommendation/tpo/get_promo_library_kpis_data_export',
    getPromoLibraryKpiUrl: baseUrl + 'promo_recommendation/tpo/get_promo_library_kpis',
    // getMechanicsLibraryTableDataUrl: baseUrl + 'promo_recommendation/tpo/get_mechanic_library_data',
    getProductConstraintsTableDataUrl: baseUrl + 'promo_recommendation/tpo/get_product_constraints_data',
    updatePlaybookDataUrl: baseUrl + 'promo_recommendation/tpo/update_playbook',
    updatePromoLibraryUrl: baseUrl + 'promo_recommendation/tpo/update_promo_library',
    optimizePlan: baseUrl + 'promo_recommendation/tpo/optimize_plan',
    getOptimizationStatus: baseUrl + 'promo_recommendation/tpo/get_optimization_status',
    getInfeasibilityExplanation: baseUrl + 'promo_recommendation/tpo/infeasibility_explanation',
    getExportDataUrl: baseUrl + 'promo_recommendation/tpo/export_tpo_data',
    getOptimizationId: baseUrl + 'promo_recommendation/tpo/get_optimization_id',
    getSyncOptimizationToTpoUrl: baseUrl + 'promo_recommendation/tpo/sync_tpo_to_optimized_plan',
    getDistinctPlanYearsUrl: baseUrl + 'promo_recommendation/tpo/distinct_plan_years',
    getPlansListUrl: baseUrl + 'promo_recommendation/tpo/comparison_plans_list',
    getPlansComparisonTableDataUrl: baseUrl + 'promo_recommendation/tpo/plans_comparison_table_data',
    getUpliftRecommendation: baseUrl + 'promo_recommendation/tpo/model_uplift',
    getLastUpdatedAtPollingUrl: baseUrl + 'promo_recommendation/tpo/get_updated_at_upsert_promo',
    getKeepDatesPromoUrl: baseUrl + 'promo_recommendation/tpo/keep_dates_and_promos',
    getPromoLibraryUiDimensions: baseUrl + 'promo_recommendation/tpo/get_promo_library_ui_dimensions',
    getExportKpiViewUrl: baseUrl + 'promo_recommendation/tpo/kpi_table_export',
    getAttributeNames: baseUrl + 'promo_recommendation/tpo/attribute_names_v2',
    getOptimizedPlanStatus: baseUrl + 'promo_recommendation_v1/optimized_plan_status',
    getPlanSummaryExportUrl: baseUrl + 'promo_recommendation_v1/plan_summary_export',
    promoLibraryMechanics: baseUrl + 'promo_recommendation/tpo/promo_library_mechanics',
    getPromolibraryPpgMetrics: baseUrl + 'promo_recommendation/tpo/promo_library_ppg_metrics',
    duplicatePlan: baseUrl + 'promo_recommendation/tpo/plan_copy',
    getPlanIndexFilterAttributes: baseUrl + 'promo_recommendation/tpo/plans/plan_index_filters',
    getCalendarDataFilterAttributes: baseUrl + 'promo_recommendation/tpo/calendar_data_filters',
    deleteAllPromosEvents: baseUrl + 'promo_recommendation/tpo/delete_all_promos_events',
    getPlanId: baseUrl + 'promo_recommendation/tpo/plan_id',
    resetPromoLibraryUrl: baseUrl + 'promo_recommendation/tpo/reset_promo_library',
    getAttributeFiltersForOptimization: baseUrl + 'promo_recommendation/tpo/attribute_filters_for_optimization',
    getPromotionCountUrl: baseUrl + 'promo_recommendation/tpo/promotion_count',
    getChildCustomersForImport: baseUrl + 'promo_recommendation/tpo/get_child_customers_by_parent_id',
    validatePlanUrl: baseUrl + 'promo_recommendation/tpo/validate_plan', // dummy url for now
    getValidatePlanResult: baseUrl + 'promo_recommendation/tpo/validate_plan/result',
    getPublishablePromos: baseUrl + 'promo_recommendation/tpo/get_publishable_promos',
    validatePromoLibraryUrl: baseUrl + 'promo_recommendation/tpo/validate_promo_library',
    getValidatePromoLibraryResult: baseUrl + 'promo_recommendation/tpo/validate_promo_library/result',
    getTpmRefreshStatusUrl: baseUrl + 'promo_recommendation/tpo/tpm_refresh_status',
};

const customGroupsBase = baseUrl + 'promo_recommendation/tpo/custom-groups';
export const customGroupsUrls = {
    indexUrl: customGroupsBase + '/index',
    getDim2OptionsUrl: customGroupsBase + '/dim2-options',
    postProductCategoriesUrl: customGroupsBase + '/product-categories',
    postDim1OptionsUrl: customGroupsBase + '/dim1-options',
    getAttributeNamesUrl: customGroupsBase + '/attribute_names',
    getDim1AttributeNamesUrl: customGroupsBase + '/dim1-attribute-names',
    listGroupsUrl: (dim2Id: number, productCategory: string) =>
        `${customGroupsBase}?dim2_id=${dim2Id}&product_category=${encodeURIComponent(productCategory)}`,
    createGroupUrl: customGroupsBase,
    updateGroupUrl: (groupId: number) => `${customGroupsBase}/${groupId}`,
    deleteGroupUrl: (groupId: number) => `${customGroupsBase}/${groupId}`,
    uiDimensionsUrl: customGroupsBase + '/ui-dimensions',
    getGroupUrl: (groupId: number) => `${customGroupsBase}/${groupId}`,
    removeItemsUrl: (groupId: number) => `${customGroupsBase}/${groupId}/items:remove`,
    removeItemsPreviewUrl: (groupId: number, dim1Id: number) =>
        `${customGroupsBase}/${groupId}/items:remove-preview?dim1_id=${dim1Id}`,
};

export const adminUrls = {
    getRedisKeys: baseUrl + 'settings/redis/keys',
    getRedisHealth: baseUrl + 'settings/redis/health',
    flushRedisKeys: baseUrl + 'settings/redis/flush',
    getAppLightupStatus: baseUrl + 'settings/applightup/status',
};

/** App refresh enforcement: version-check (poll) and version-bump (admin). Path uses /pnp/settings/app/ per backend. */
const settingsAppBase = baseUrl ?? '';
const settingsAppPathPrefix = settingsAppBase.endsWith('pnp/') ? '' : 'pnp/';
export const appVersionUrls = {
    /** GET: returns { currentVersion: number }. No payload; use for bootstrap after login/refresh. */
    getCurrentVersion: settingsAppBase + settingsAppPathPrefix + 'settings/app/current-version',
    versionCheck: (clientVersion: number) =>
        `${settingsAppBase}${settingsAppPathPrefix}settings/app/version-check?client_version=${clientVersion}`,
    versionBump: settingsAppBase + settingsAppPathPrefix + 'settings/app/version-bump',
};

export const migrationUrls = {
    listMigrations: (dbType?: string) => baseUrl + 'settings/migrations' + (dbType ? `?db_type=${dbType}` : ''),
    /** fileName may include slashes (e.g. common/2026_....sql); path segments must be encoded. */
    runMigration: (fileName: string, dbType: string = 'postgres') =>
        `${baseUrl}settings/migrations/run/${encodeURIComponent(fileName)}?db_type=${dbType}`,
    runAll: (dbType: string = 'postgres') => baseUrl + 'settings/migrations/run-all?db_type=' + dbType,
    acknowledgeTamper: (fileName: string, dbType: string = 'postgres') =>
        `${baseUrl}settings/migrations/${encodeURIComponent(fileName)}/acknowledge-tamper?db_type=${dbType}`,
    /** POST JSON body: { items: { file_name, db_type }[] } — record as applied without running SQL. */
    markCompleted: () => baseUrl + 'settings/migrations/mark-completed',
};

export const refreshJobsUrls = {
    crossDimensionOptions: baseUrl + 'settings/refresh-jobs/cross-dimension/options',
    crossDimensionRun: baseUrl + 'settings/refresh-jobs/cross-dimension/run',
    crossDimensionLastUpdated: (schema: string) =>
        baseUrl + 'settings/refresh-jobs/cross-dimension/last-updated?schema=' + encodeURIComponent(schema),
    dimRelationshipRun: baseUrl + 'settings/refresh-jobs/refresh-dim-relationships',
    createIndexesOptions: baseUrl + 'settings/refresh-jobs/create-indexes/options',
    createIndexesRun: baseUrl + 'settings/refresh-jobs/create-indexes/run',
};

export const bestWeeksUrls = {
    getBestWeeksDrillDownDataUrl: baseUrl + 'best_weeks/weeks_detail',
};

export const profitPoolUrls = {
    getProfitPoolDataUrl: baseUrl + 'profit_pool/data',
};

export const ticketsUrls = {
    postCreateTicket: baseUrl + 'tickets/create',
};

export const simulatorToolsUrls = {
    validateKpiSheet: baseUrl + 'pricing_simulator_v2/tools/validate_kpi_sheet',
    uploadKpiSheet: baseUrl + 'pricing_simulator_v2/tools/upload_kpi_sheet',
    resetAllTables: baseUrl + 'pricing_simulator_v2/tools/reset_all_tables',
    generateScenarioMetricsScript: baseUrl + 'pricing_simulator_v2/tools/generate_scenario_metrics_script',
    detectConfigSheets: baseUrl + 'pricing_simulator_v2/tools/detect_config_sheets',
    validateConfigSheets: baseUrl + 'pricing_simulator_v2/tools/validate_config_sheets',
    uploadConfigSheets: baseUrl + 'pricing_simulator_v2/tools/upload_config_sheets',
    validateTable: (tableName: string) => baseUrl + `pricing_simulator_v2/tools/validate_table/${tableName}`,
};
